import {
  BusAssistanResources,
  DriversResources,
  VehiclesResources,
} from "../tools";
import { useFormState } from "react-final-form";
import { Button } from "@material-ui/core";
import { useDataProvider, useNotify } from "react-admin";
import moment from "moment/moment";

interface IClipboardButton {
  index: number;
  isToSchool: boolean;
  school: ISchool;
}

const ClipboardButton = ({ isToSchool, index, school }: IClipboardButton) => {
  const { values } = useFormState();
  const provider = useDataProvider();
  const notify = useNotify();

  const handleButton = async (clonedFormData: any) => {
    if (clonedFormData.route.backupDriverIds.length > 0) {
      var driverBackups = await DriversResources(
        clonedFormData.route.backupDriverIds,
        provider
      );
    }

    if (clonedFormData.route.backupBusAssistantIds.length > 0) {
      var busAssistanBackups = await BusAssistanResources(
        clonedFormData.route.backupBusAssistantIds,
        provider
      );
    }

    if (clonedFormData.route.backupVehicleIds.length > 0) {
      var vehicleBackups = await VehiclesResources(
        clonedFormData.route.backupVehicleIds,
        provider
      );
    }

    if (clonedFormData.route.driverId !== null) {
      var driver = await DriversResources(
        clonedFormData.route.driverId,
        provider
      );
    }
    if (clonedFormData.route.busAssistantId !== null) {
      var busAssistants = await BusAssistanResources(
        clonedFormData.route.busAssistantId,
        provider
      );
    }
    if (clonedFormData.route.vehicleId !== null) {
      var vehicle = await VehiclesResources(
        clonedFormData.route.vehicleId,
        provider
      );
    }

    var schoolData = `School: ${school.name} \n ${school.address} \n\n`;

    var waveData =
      `${clonedFormData.route.name}\n` +
      `Sch: ${school.name} \n` +
      `Start time: ${clonedFormData.route.startTime} \n` +
      `End Time: ${clonedFormData.route.endTime} \n\n`;

    var driverData =
      `Driver: ${driver ? driver[0].fullName : ""},${
        driverBackups?.map((data: any) => {
          return ` [${data?.fullName}]`;
        }) || ""
      } \n` +
      `BA: ${busAssistants ? busAssistants[0].fullName : ""},${
        busAssistanBackups?.map((data: any) => {
          return ` [${data?.fullName}]`;
        }) || ""
      } \n` +
      `Bus: ${vehicle ? vehicle[0].plateNumber : ""},${
        vehicleBackups?.map((data: any) => {
          return ` [${data?.plateNumber}]`;
        }) || ""
      } \n\n`;

    var studentData = clonedFormData.route.routeLocations.map((item: any) => {
      return (
        `${moment(item.arrivedAt, "HH:mm").format("HH:mm")}\n` +
        `${item.order}. ${item.blockNumber} ${item.street} ${item.postalCode}\n` +
        `${item.remark !== null ? `${item.remark}\n` : ""}` +
        `${item.students
          .sort((a: any, b: any) => a.id - b.id)
          .map((data: any) => {
            return `${data.locationCode} - ${data.firstName} ${data.lastName}\n`;
          })
          .join("")} \n`
      );
    });

    if (isToSchool) {
      navigator.clipboard.writeText(
        `${waveData + driverData + studentData.join("") + schoolData}`
      );
    } else {
      navigator.clipboard.writeText(
        `${waveData + driverData + schoolData + studentData.join("")}`
      );
    }

    notify("Text copied to clipboard");
  };

  return (
    <Button
      variant="contained"
      size="small"
      style={{
        fontSize: "10px",
        color: "white",
        backgroundColor: "#4F5B7B",
        fontWeight: "bold",
      }}
      onClick={() => {
        handleButton(values);
        console.log("valuu", values);

        //   notify("Text copied to clipboard");
      }}
    >
      Copy Route to Text
    </Button>
  );
};

export default ClipboardButton;
